import {
  marginFields,
  marginProps,
  MarginProps,
} from '../../../page-builder/puck/reusable-props/margin';
import { ComponentConfig, FieldLabel } from '@measured/puck';
import { CartComponent } from './Cart';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../services/constants';
import CustomTooltip from '../../../components/common/tooltip';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import { getcurrentDeviceType } from '../../utils/helper';
import {
  paddingFields,
  paddingProps,
  PaddingProps,
} from '../../puck/reusable-props/padding';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';
import ColorPicker from '../../puck/reusable-props/ColorPicker';
import { ICardFields } from '../../interface/formInterface';
import { defaultBorderProps } from '../../utils/constants';
import WithAccordion from '../customComponents/CustomAccordion';
import { Switch, ToggleButtonGroup, ToggleButton } from '@mui/material';
import BackgroungColorComponent from '../customComponents/BackgroungColorComponent';
import { CardFieldOption } from './CardFieldOption';
import { outlineProps } from '../../puck/reusable-props/Outline';
export type CartProps = {
  border: IBorderValueProps;
  productPricePosition: string;
  placeholder: ICardFields;
  productSubtitle: ICardFields;
  background: {
    color: string;
    isInherit: boolean;
  };
  showDescription: boolean;
  cartCustomization: {
    hideImage: boolean;
    hideCloseButton: boolean;
    descriptionPosition: string;
  };
  colorCustomization: {
    price: string;
    productRemove: string;
    quantityIncreaseIcon: string;
    quantityDecreaseIcon: string;
    quantityDecreaseButton: string;
    quantityIncreaseButton: string;
    quantityBgColor: {
      color: string;
      isInherit: boolean;
    };
    quantityTextColor: string;
  };
  showQuantityButtons: boolean;
} & MarginProps &
  PaddingProps &
  showComponentProps;

export const Cart = ({
  useAppSelector,
  useAppDispatch,
}: ReduxSelectorProps & ReduxDispatchProps): ComponentConfig<CartProps> => {
  return {
    label: (
      <CustomTooltip title="Cart">
        <span>Cart</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      placeholder: {
        type: 'custom',
        label: 'Place Holder',
        render: ({ value, onChange }) => {
          return (
            <CardFieldOption
              key="placeholder"
              name="Product Name Customization"
              value={value}
              onChange={onChange}
            />
          );
        },
      },
      productSubtitle: {
        type: 'custom',
        label: 'Place Holder',
        render: ({ value, onChange }) => {
          return (
            <CardFieldOption
              key="placeholder"
              name="Subtitle Customization"
              value={value}
              onChange={onChange}
            />
          );
        },
      },
      cartCustomization: {
        type: 'custom',
        label: 'Cart Customization',
        render: ({ value, onChange }) => {
          const options = [
            { label: 'Left', value: 'left' },
            { label: 'Right', value: 'right' },
          ];
          return (
            <WithAccordion title="Cart Customization">
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Hide Product Image">
                      <span>Hide Product Image</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.hideImage}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      hideImage: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Hide Remove Button">
                      <span>Hide Remove Button</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.hideCloseButton}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      hideCloseButton: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
              <FieldLabel
                label={
                  (
                    <CustomTooltip title={'Descreiption Position'}>
                      <span>Description Position</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }
                el="div"
                className="w-full">
                <div className="w-full p-2">
                  <ToggleButtonGroup
                    value={value?.descriptionPosition}
                    exclusive
                    className="w-full"
                    onChange={(_e, selectValue) => {
                      selectValue &&
                        onChange({
                          ...value,
                          descriptionPosition: selectValue,
                        });
                    }}>
                    {options.map((option, index: number) => (
                      <ToggleButton
                        key={index}
                        size="small"
                        value={option.value}
                        disableRipple
                        aria-label={option.value}
                        className="flex-1">
                        {option.label}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                </div>
              </FieldLabel>
            </WithAccordion>
          );
        },
      },
      colorCustomization: {
        type: 'custom',
        label: 'Color Customization',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Color Customization">
              <ColorPicker
                value={value?.price}
                onChange={color => onChange({ ...value, price: color })}
                label="Price Color"
                tooltip="price"
              />
              <ColorPicker
                value={value?.productRemove}
                onChange={color => onChange({ ...value, productRemove: color })}
                label="Product Remove Color"
                tooltip="productRemove"
              />
              <ColorPicker
                value={value?.quantityIncreaseIcon}
                onChange={val =>
                  onChange({ ...value, quantityIncreaseIcon: val })
                }
                label="Quantity Increase Icon Color"
                tooltip="quantityIncreaseIcon"
              />
              <ColorPicker
                value={value?.quantityDecreaseIcon}
                onChange={color =>
                  onChange({ ...value, quantityDecreaseIcon: color })
                }
                label="Quantity Decrease Icon Color"
                tooltip="quantityDecreaseIcon"
              />
              <ColorPicker
                value={value?.quantityIncreaseButton}
                onChange={color =>
                  onChange({ ...value, quantityIncreaseButton: color })
                }
                label="Quantity Increase Button Color"
                tooltip="quantityIncreaseButton"
              />
              <ColorPicker
                value={value?.quantityDecreaseButton}
                onChange={color =>
                  onChange({ ...value, quantityDecreaseButton: color })
                }
                label="Quantity Decrease Button Color"
                tooltip="quantityDecreaseButton"
              />
              <ColorPicker
                value={value?.quantityTextColor}
                onChange={color =>
                  onChange({ ...value, quantityTextColor: color })
                }
                label="Quantity Text Color"
                tooltip="quantityTextColor"
              />
              <BackgroungColorComponent
                value={value?.quantityBgColor}
                onChange={val => {
                  onChange({
                    ...value,
                    quantityBgColor: val,
                  });
                }}
                title="Quantity Background Color"
              />
            </WithAccordion>
          );
        },
      },
      productPricePosition: {
        type: 'radio',
        label: 'Product Price Position',

        options: [
          { label: 'Left', value: 'left' },
          { label: 'Right', value: 'right' },
        ],
      },
      showDescription: {
        type: 'radio',
        label: 'Show Product Description',

        options: [
          { label: 'On', value: true },
          { label: 'Off', value: false },
        ],
      },
      showQuantityButtons: {
        type: 'radio',
        label: 'Show Quantity Buttons',
        options: [
          { label: 'Show', value: true },
          { label: 'Hide', value: false },
        ],
      },
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      ...backgroungFields,
      ...paddingFields,
      ...marginFields,
    },
    defaultProps: {
      cartCustomization: {
        hideImage: false,
        hideCloseButton: false,
        descriptionPosition: 'left',
      },
      colorCustomization: {
        price: '#000000',
        quantityIncreaseIcon: '#a0a7b2',
        quantityDecreaseIcon: '#a0a7b2',
        productRemove: '#9ca3af',
        quantityDecreaseButton: '#ffffff',
        quantityIncreaseButton: '#ffffff',
        quantityBgColor: {
          color: '#000000',
          isInherit: false,
        },
        quantityTextColor: '#ffffff',
      },
      placeholder: {
        placeholder: '',
        color: '#000000',
        fontSize: '14',
        fontWeight: '300',
        lineHeight: '1.5',
        textAlign: 'left',
        fontFamily: 'sans-serif',
        letterSpace: '0',
        textColor: {
          color: '#000000',
          isInherit: false,
        },
        textBackgroundColor: {
          color: '#ffffff',
          isInherit: false,
        },
        ...defaultBorderProps,
        ...outlineProps,
      },
      productSubtitle: {
        placeholder: '',
        color: '#000000',
        fontSize: '14',
        fontWeight: '300',
        lineHeight: '1.5',
        textAlign: 'left',
        fontFamily: 'sans-serif',
        letterSpace: '0',
        textColor: {
          color: '#000000',
          isInherit: false,
        },
        textBackgroundColor: {
          color: '#ffffff',
          isInherit: false,
        },
        ...defaultBorderProps,
        ...outlineProps,
      },
      showComponent: ['desktop', 'tablet', 'mobile'],
      ...marginProps,
      ...paddingProps,
      ...borderProps,
      productPricePosition: 'left',
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      showDescription: true,
      showQuantityButtons: true,
    },
    render: ({
      margin,
      showComponent,
      editMode,
      padding,
      border,
      placeholder,
      productSubtitle,
      background,
      colorCustomization,
      productPricePosition,
      cartCustomization,
      showDescription,
      showQuantityButtons,
    }) => {
      const currentWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(currentWidth, editMode);
      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <CartComponent
              colorCustomization={colorCustomization}
              cartCustomization={cartCustomization}
              border={border}
              placeholder={placeholder}
              margin={margin}
              padding={padding}
              productSubtitle={productSubtitle}
              background={background}
              currentDeviceType={currentDeviceType}
              useAppSelector={useAppSelector}
              useAppDispatch={useAppDispatch}
              productPricePosition={productPricePosition}
              showDescription={showDescription}
              showQuantityButtons={showQuantityButtons}
            />
          )}
        </>
      );
    },
  };
};
